/* @flow */
import { combineReducers } from 'redux';

/*
 * For unit tests
 *
 */

export default (...args: any): any =>
  combineReducers(...args);
